"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OidcProvider = exports.useOidcFetch = exports.withOidcFetch = exports.useOidcIdToken = exports.useOidcAccessToken = exports.useOidc = exports.OidcUserStatus = exports.useOidcUser = exports.OidcSecure = exports.withOidcSecure = void 0;
var OidcSecure_1 = require("./OidcSecure");
Object.defineProperty(exports, "withOidcSecure", { enumerable: true, get: function () { return OidcSecure_1.withOidcSecure; } });
Object.defineProperty(exports, "OidcSecure", { enumerable: true, get: function () { return OidcSecure_1.OidcSecure; } });
var User_1 = require("./User");
Object.defineProperty(exports, "useOidcUser", { enumerable: true, get: function () { return User_1.useOidcUser; } });
Object.defineProperty(exports, "OidcUserStatus", { enumerable: true, get: function () { return User_1.OidcUserStatus; } });
var ReactOidc_1 = require("./ReactOidc");
Object.defineProperty(exports, "useOidc", { enumerable: true, get: function () { return ReactOidc_1.useOidc; } });
Object.defineProperty(exports, "useOidcAccessToken", { enumerable: true, get: function () { return ReactOidc_1.useOidcAccessToken; } });
Object.defineProperty(exports, "useOidcIdToken", { enumerable: true, get: function () { return ReactOidc_1.useOidcIdToken; } });
var FetchToken_1 = require("./FetchToken");
Object.defineProperty(exports, "withOidcFetch", { enumerable: true, get: function () { return FetchToken_1.withOidcFetch; } });
Object.defineProperty(exports, "useOidcFetch", { enumerable: true, get: function () { return FetchToken_1.useOidcFetch; } });
var OidcProvider_1 = require("./OidcProvider");
Object.defineProperty(exports, "OidcProvider", { enumerable: true, get: function () { return OidcProvider_1.OidcProvider; } });
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@axa-fr/react-oidc/dist/index.js
// module id = 93
// module chunks = 0